import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["type", "aria-label", "disabled"];
const _hoisted_2 = {
    key: 0,
    class: "rec-record-button__label"
};
import SvgIcon from "@/common/components/SvgIcon.vue";
import { vTooltip } from "@/common/directives/tip-directive";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecordButton',
    props: {
        icon: {},
        variant: {},
        label: {},
        backdrop: { type: Boolean, default: false },
        tooltip: { default: "" },
        type: { default: "button" },
        disabled: { type: Boolean },
        pulse: { type: Boolean },
        loading: { type: Boolean },
        size: { default: "large" }
    },
    setup(__props) {
        const props = __props;
        const wrapperClasses = computed(() => ({
            "rec-record-button": true,
            "rec-record-button--backdrop": props.backdrop,
            "rec-record-button--loading": props.loading,
            [`rec-record-button--${props.size}`]: !!props.size
        }));
        const buttonClasses = computed(() => ({
            "rec-record-button__control": true,
            [`rec-record-button__control--${props.variant}`]: true,
            "rec-record-button__control--pulse": props.pulse && !props.loading
        }));
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(wrapperClasses.value),
                type: props.type,
                "aria-label": props.label,
                disabled: props.disabled
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(buttonClasses.value)
                }, [
                    (props.loading)
                        ? (_openBlock(), _createBlock(SvgIcon, {
                            key: 0,
                            icon: "loader-spin"
                        }))
                        : (_openBlock(), _createBlock(SvgIcon, {
                            key: 1,
                            icon: props.icon
                        }, null, 8, ["icon"]))
                ], 2),
                (props.backdrop && props.label)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.label), 1))
                    : _createCommentVNode("", true)
            ], 10, _hoisted_1)), [
                [_unref(vTooltip), props.tooltip]
            ]);
        };
    }
});
